export enum NAVIGATION_MENU_LIST {
  HOME = 'HOME',
  TRAINING = 'TRAINING',
  COACHING = 'COACHING',
  ASSETS = 'ASSETS',
  CALL_AI = 'CALL_AI',
  DSR = 'DSR',
  SELLER_INTEL = 'SELLER_INTEL',
  REVENUE_INTELLIGENCE = 'REVENUE_INTELLIGENCE',
  TEAM_ANALYTICS = 'TEAM_ANALYTICS',
  ASSISTANT = 'ASSISTANT',
}

export enum TRAINING_SUB_MENU_LIST {
  TRAINING_SERIES = 'TRAINING_SERIES',
  TRAINING_MODULES = 'TRAINING_MODULES',
  TRAINING_ILT_SESSIONS = 'TRAINING_ILT_SESSIONS',
  TRAINING_LEADERBOARD = 'TRAINING_LEADERBOARD',
  TRAINING_TASKS = 'TRAINING_TASKS',
  TRAINING_FILES = 'TRAINING_FILES',
  TRAINING_AI_TUTORIALS = 'TRAINING_AI_TUTORIALS',
}

export enum ASSETS_SUB_MENU_LIST {
  ASSETS_ASSETS = 'ASSETS_ASSETS',
  ASSETS_MY_ASSETS = 'ASSETS_MY_ASSETS',
  ASSETS_INTERACTIONS = 'ASSETS_INTERACTIONS',
}

export enum CALL_AI_SUB_MENU_LIST {
  CALL_AI_RECORDINGS = 'CALL_AI_RECORDINGS',
  CALL_AI_TEAM_RECORDINGS = 'CALL_AI_TEAM_RECORDINGS',
  CALL_AI_UPCOMING_MEETINGS = 'CALL_AI_UPCOMING_MEETINGS',
  CALL_AI_MY_ANALYTICS = 'CALL_AI_MY_ANALYTICS',
  CALL_AI_PREFERENCES = 'CALL_AI_PREFERENCES',
  CALL_AI_LIBRARIES = 'CALL_AI_LIBRARIES',
  CALL_AI_ESSENTIALS = 'CALL_AI_ESSENTIALS',
}

export enum COACHING_SUB_MENU_LIST {
  COACHING_SESSIONS = 'COACHING_SESSIONS',
  MISSION_REVIEW = 'MISSION_REVIEW',
}

export enum DSR_SUB_MENU_LIST {
  DSR_ROOMS = 'DSR_ROOMS',
  DSR_TEMPLATES = 'DSR_TEMPLATES',
  DSR_INSIGHTS = 'DSR_INSIGHTS',
  DSR_DEALS = 'DSR_DEALS',
  DSR_SETTINGS = 'DSR_SETTINGS',
}

export enum TEAM_ANALYTICS_SUB_MENU_LIST {
  TEAM_ANALYTICS_MY = 'TEAM_ANALYTICS_MY',
  TEAM_ANALYTICS_HIERARCHY_REPORTS = 'TEAM_ANALYTICS_HIERARCHY_REPORTS',
  TEAM_ANALYTICS_RELATIONSHIP_REPORTS = 'TEAM_ANALYTICS_RELATIONSHIP_REPORTS',
  TEAM_ANALYTICS_CALLAI = 'TEAM_ANALYTICS_CALLAI',
  TEAM_ANALYTICS_COACHING = 'TEAM_ANALYTICS_COACHING',
  ANALYTICS_READINESS_INDEX = 'ANALYTICS_READINESS_INDEX',
}
